import { Component, computed, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { RecordSwipperItem } from 'src/app/models/record-swiper';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-slider-collection-item',
  templateUrl: './slider-collection-item.component.html',
  styleUrls: [
    '../slider.component.scss',
    './slider-collection-item.component.scss'
  ],
})
export class SliderCollectionItemComponent implements OnInit {
  @Input()
  item: RecordSwipperItem;

  @Input()
  visible: boolean;

  @Input()
  active: boolean;

  @Output()
  clicked = new EventEmitter<RecordSwipperItem>();

  title: string;
  cover: string;

  isHover: boolean;

  showAuthorViewCarousel = signal(this.configService.get().showAuthorViewCarousel);
  readonly ellipsisTitle = computed(() => this.showAuthorViewCarousel() ? 2 : 3);

  constructor(private configService: ConfigService) {}

  ngOnInit() {
    this.setCover();
    this.title = this.getCompleteTitle();
  }

  setCover() {
    if (this.item.covers && this.item.covers.length) {
      this.cover = this.item.covers[0];
    }
  }

  setStateHover(state: boolean) {
    this.isHover = state;
  }

  private getCompleteTitle(): string {
    let title = this.item.title;

    if (this.item.subtitle != null) {
      const separator = this.configService.get().titleSeparator;
      title += separator + ' ' + this.item.subtitle;
    }
    return title;
  }

  onClicked(item: RecordSwipperItem) {
    this.clicked.emit(item);
  }
}
